import { render } from "./ResearchWorkspace.vue?vue&type=template&id=cbc43dc4&scoped=true&ts=true"
import script from "./ResearchWorkspace.vue?vue&type=script&lang=ts"
export * from "./ResearchWorkspace.vue?vue&type=script&lang=ts"

import "./ResearchWorkspace.vue?vue&type=style&index=0&id=cbc43dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc43dc4"]])

export default __exports__